import { Box, Typography, Divider } from '@mui/material';

interface PriceExpiryCardProps {
    price?: number | null;
    billingCycle?: string;
    expiryTimeStamp: Date;
    isPlanActive: boolean;
}

export const PriceExpiryCard = ({ price, billingCycle, expiryTimeStamp, isPlanActive }: PriceExpiryCardProps) => {
    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 3,
            padding: 2.5,
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            borderRadius: 2,
            border: '1px solid #e2e8f0'
        }}>
            {price !== null && (
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }}>
                        💰
                    </Typography>
                    <Typography 
                        sx={{ 
                            fontSize: '1.75rem',
                            fontWeight: 700,
                            color: '#1e293b',
                            letterSpacing: '-0.5px'
                        }}
                    >
                        ₹{price}
                    </Typography>
                    <Typography sx={{ fontSize: '0.875rem', color: '#64748b', fontWeight: 500 }}>
                        / {billingCycle || 'month'}
                    </Typography>
                </Box>
            )}
            <Divider orientation="vertical" flexItem sx={{ borderColor: '#cbd5e1' }} />
            <Box>
                <Typography sx={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 500, mb: 0.25 }}>
                    {isPlanActive ? 'Expires on' : 'Expired on'}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#334155', fontWeight: 600 }}>
                    {new Date(expiryTimeStamp).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    })}
                </Typography>
            </Box>
        </Box>
    );
};
